<template class="${selected ? 'current' : ''}" show.bind="selected">
  <au-slot></au-slot>
  <au-compose
    if.bind="path"
    component.bind="path"
    model.bind="model"
    component.ref="stepViewModel"
  ></au-compose>
</template>
